import gql from 'graphql-tag';


export const IRIDIUM_EVENTS_SUBSCRIPTION = gql`
subscription iridiumEvent {
  iridiumEvent{
    _id
    dateCreated
    msg {
      ieid
      nombielongi
      cdr
      imei
      momsn
      mtmsn
      timestamp
      payload {
        valores {
          tag
          valor
        }
        alarmas {
          tipo
          lluvia
          altlm
        }
      }
    }
  }
  }`